import { PrimaryLoadingIndicator } from "./PrimaryLoadingIndicator";

export function FullScreenLoading() {
  return (
    <div className={"min-h-screen min-w-full flex items-center justify-center"}>
      <PrimaryLoadingIndicator size={"large"} />
    </div>
  );
}
